import EnterFullScreenIcon from "~icons/local/enter-full-screen";
import ExitFullScreenIcon from "~icons/local/exit-full-screen";
import useModal from "@/lib/modal/useModal.js";
import { useEffect, useRef, useState } from "react";
import * as OV from "online-3d-viewer";
import FileIcon from "~icons/local/file-light";
import Download from "@/lib/Download";
import Online3DViewer from "@/lib/Online3DViewer";

export default function CadModel({
  hide,
  show,
  url,
}: {
  hide?: () => void;
  show: boolean;
  url?: string;
}) {
  const { showModal, closeModal } = useModal();

  return (
    <div className={`w-full h-full relative ${show ? "" : "hidden"}`}>
      {url ? (
        <>
          <EnterFullScreenIcon
            className="absolute cursor-pointer top-4 left-4"
            onClick={() =>
              showModal(
                <div className="w-screen h-screen">
                  <ExitFullScreenIcon
                    className="cursor-pointer fixed top-7 left-7"
                    onClick={closeModal}
                  />
                  <Online3DViewer className="h-full w-full" fileUrl={url} />
                </div>,
              )
            }
          />
          <div className="flex gap-3 absolute top-4 right-4">
            <Download fileUrl={url} />
          </div>
          <CadModelViewerLite fileUrl={url} />
        </>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-start">
          <div className="p-8 text-center">
            No cad modal (.stp) file for this part.
          </div>
        </div>
      )}
      {hide && (
        <FileIcon
          className="absolute cursor-pointer bottom-4 right-4 size-14 border shadow-xl p-2"
          onClick={hide}
        />
      )}
    </div>
  );
}

function CadModelViewerLite({ fileUrl }: { fileUrl: string }) {
  const viewerContainerRef = useRef<HTMLDivElement>(null);
  const [modelLoaded, setModelLoaded] = useState(false);

  useEffect(() => {
    const container = viewerContainerRef.current!;
    const viewer = new OV.EmbeddedViewer(container, {
      onModelLoaded: () => setModelLoaded(true),
    });
    viewer.LoadModelFromUrlList([fileUrl]);
    const resizeObserver = new ResizeObserver(() => viewer.Resize());
    resizeObserver.observe(container);
    return () => {
      viewer.Destroy();
    };
  }, [fileUrl]);

  return (
    <div
      className={`w-full h-full ${modelLoaded ? "" : "invisible"}`}
      ref={viewerContainerRef}
      key={fileUrl}
    />
  );
}
